import React from 'react'
import { FaArrowAltCircleLeft } from 'react-icons/fa'
import { Outlet, NavLink, useParams } from 'react-router-dom'


const StoreAdminMenu = () => {
    const { name } = useParams()

    return (
        <div className='page-body'>
            <div className="multi-content-page">
                <div className="page-side-menu">
                    <div className="menu-items-list">
                        <div className='page-menu-item'>
                            <NavLink to={`/b/${name}/`}><FaArrowAltCircleLeft /> Back</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/`}>Dashboard</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/orders`}>Orders</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/invoices`}>Invoices</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/admins`}>Admins</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/products`}>{`products`}</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/shelves`}>{`shelves`}</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/branches`}>{`Branches`}</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/parents`}>Parent</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/followers`}>followers</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/promotions`}>promotions</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/plan`}>$ plan</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/b/manage/${name}/edit`}>Settings</NavLink>
                        </div>
                    </div>
                </div>
                <div className="org-content">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default StoreAdminMenu
